const PAGINATED_INDEX_QUERY_KEYS = ['page', 'search', 'title', 'slug', 'description', 'name', 'specialisation', 'site', 'category', 'specialist'];

export function paginatedIndexQuery() {
  if (typeof window === 'undefined') {
    return {};
  }

  const params = new URLSearchParams(window.location.search);

  return PAGINATED_INDEX_QUERY_KEYS.reduce((acc, key) => {
    const value = params.get(key);
    if (value != null && value !== '') {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export function paginatedIndexRouteOptions(extra) {
  if (arguments.length > 0) {
    return extra && Object.keys(extra).length > 0 ? extra : undefined;
  }

  const query = paginatedIndexQuery();
  return Object.keys(query).length > 0 ? query : undefined;
}
